import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface StatusInfoItem {
  label: string;
  description: string;
}

export interface StatusInfoDialogData {
  title: string;
  items: StatusInfoItem[];
}

@Component({
  selector: 'app-status-info-dialog',
  template: `
    <div style="min-width: 400px; max-width: 520px;">
      <div style="background: #4358a6; color: #fff; padding: 16px 24px; margin: -24px -24px 0 -24px; border-radius: 4px 4px 0 0; display: flex; justify-content: space-between; align-items: center;">
        <h2 style="margin: 0; font-size: 17px; font-weight: 600;">{{ data.title }}</h2>
        <button type="button" (click)="dialogRef.close()" style="background: none; border: none; color: #fff; font-size: 20px; cursor: pointer; line-height: 1;">&times;</button>
      </div>
      <div style="padding: 20px 0 4px 0;">
        <div *ngFor="let item of data.items" style="margin-bottom: 14px; padding-bottom: 14px; border-bottom: 1px solid #f0f0f0;">
          <span style="font-weight: 700; font-size: 14px; color: #111827;">{{ item.label }}</span>
          <p style="margin: 4px 0 0 0; font-size: 13px; color: #6b7280; line-height: 1.5;">{{ item.description }}</p>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end; padding-top: 4px;">
        <button
          type="button"
          (click)="dialogRef.close()"
          style="background: #4358a6; color: #fff; border: none; border-radius: 6px; padding: 7px 24px; font-size: 13px; font-weight: 500; cursor: pointer;">
          Schließen
        </button>
      </div>
    </div>
  `,
  styles: []
})
export class StatusInfoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<StatusInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StatusInfoDialogData
  ) {}
}
